import * as React from 'react';

export const FileUploadIcon: React.FC<React.PropsWithChildren<unknown>> = () => WorkdayUpArrow;

const WorkdayUpArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    focusable="false"
    role="presentation"
    viewBox="0 0 56 56"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="28" cy="28" r="22" fill="#FFF" />
      <path
        fill="#005DBA"
        fillRule="nonzero"
        d="M28 52C14.745 52 4 41.255 4 28S14.745 4 28 4s24 10.745 24 24-10.745 24-24 24zm0-2c12.15 0 22-9.85 22-22S40.15 6 28 6 6 15.85 6 28s9.85 22 22 22zm-6.732-22.664a.506.506 0 0 1-.71-.003l-.701-.7a.495.495 0 0 1-.003-.71l7.777-7.779a.498.498 0 0 1 .352-.144.48.48 0 0 1 .356.144l7.778 7.778a.506.506 0 0 1-.003.71l-.7.701a.495.495 0 0 1-.711.003L29 21.634V37.26c0 .273-.226.5-.505.5h-.99a.495.495 0 0 1-.505-.5V21.604l-5.732 5.732z"
      />
    </g>
  </svg>
);
